"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DialogOffline;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _WifiOffRounded = _interopRequireDefault(require("@material-ui/icons/WifiOffRounded"));
var _CloseRounded = _interopRequireDefault(require("@material-ui/icons/CloseRounded"));
var _styles = require("./styles");
var _utils = require("../../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function DialogOffline() {
  var classes = (0, _styles.useStyles)();
  var [offLineModal, setOffLineModal] = (0, _utils.useLocalStorage)('offLineModal', false);
  var [open, setOpen] = (0, _react.useState)(true);
  var handleClose = () => {
    setOpen(false);
  };
  var handleSetStorage = () => {
    setOffLineModal(true);
    setOpen(false);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !offLineModal && /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    classes: classes,
    open: open
  }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, {
    disableTypography: true,
    className: classes.dialogTitle
  }, /*#__PURE__*/_react.default.createElement(_WifiOffRounded.default, {
    color: "primary"
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "h2",
    className: classes.title
  }, " Leitura Offline "), /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.buttonClose,
    onClick: handleClose
  }, /*#__PURE__*/_react.default.createElement(_CloseRounded.default, null))), /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
    className: classes.dialogContent
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.body
  }, "Caso sua internet fique indispon\xEDvel, n\xE3o se preocupe, voc\xEA poder\xE1 continuar a leitura deste livro normalmente. Para isso, n\xE3o feche ou recarregue seu navegador!")), /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: "primary",
    onClick: handleSetStorage,
    className: classes.button
  }, "N\xE3o desejo ver novamente")));
}